<template>
  <v-form
    ref="form"
    v-model="valid"
    style="width: 100%"
    @submit.prevent="submit()"
  >
    <v-card :elevation="elevation" style="width: 100%">
      <v-card-text>
        <v-row>
          <v-col>
            <v-textarea
              v-model="form.notes"
              outlined
              rows="2"
              placeholder="Add a note about this call"
              auto-grow
              hide-details=""
            ></v-textarea> </v-col
        ></v-row>
    
    
        <v-row>
          <v-col cols="3">
            <channel-notes-select outlined v-model="form.channel" small dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn v-if="value" @click="cancel" class="mr-2">Cancel</v-btn>
            <v-btn color="info" @click="save" :disabled="$v.$invalid"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import validationMixin from "@/mixins/validationMixin";
import ChannelNotesSelect from "components/ChannelNotesSelect";

export default {
  mixins: [validationMixin],
  components: {
    ChannelNotesSelect,
  },
  validations: {
    form: {
      notes: {
        required,
      },
      channel: {
        required
      }
    },
  },
  validationMessages: {
    form: {
      notes: {
        required: "Please write your notes",
      },
      channel: {
        required: "Channel required",
      },
    },
  },

  props: {
    clientId: [String, Number],
    value: [Object],
    elevation: Number,
  },
  data() {
    let defaultForm = {};
    if (this.value) {
      defaultForm = { ...this.value };
    }
    return {
      valid: false,
      form: {
        notes: "",
        channel: "",
        clientId: this.clientId,
        authorId: "",
        isCompleted: false,
        ...defaultForm,
      },
    };
  },

  watch: {},
  computed: {
    ...mapState({
      notes: (state) => state.notes,
      account: (state) => state.account.data.user,
    }),

    propValue() {
      return this.value;
    },
  },
  methods: {
    ...mapActions({
      noteCreate: "notes/create",
      noteUpdate: "notes/update",
    }),
    cancel() {
      this.$emit("cancel");
    },
    async save() {
      let payload = {
        ...this.form,
        authorId: this.account.id,
        dateCreated: new Date(),
      };
      if (this.value) {
        await this.noteUpdate(payload);
      } else {
        await this.noteCreate(payload);
      }
      this.form = {
        channel: "Other",
        notes: "",
        clientId: this.clientId,
        authorId: "",
        isCompleted: false,
      };
      this.cancel();
      this.$emit("updated");
    },
  },
};
</script>
